<template>

    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addBrandConfiguration/>
    </v-dialog>

</template>

<script>
    import {BrandConfiguration} from '../../../store/namespace-helper'

    import addBrandConfiguration from '../../Shared/AddBrandConfigration.vue'

    export default {
      name: 'add-brand-configuration-dialog',
      components: {
        addBrandConfiguration
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[BrandConfiguration.getters.getOpenDialogState]
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings/BrandConfiguration/AddBrandConfigurationDialog.vue